import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { AppService } from '@core/services/app.service';
import { IonNav, ModalController, Platform } from '@ionic/angular';
import { IDaireBorcAlacak } from '@models/finance';
import { BorclandirComponent } from '../borclandir/borclandir.component';
import { CariHesapEkstresiComponent } from '../cari-hesap-ekstresi/cari-hesap-ekstresi.component';
import { OdemeAlComponent } from '../odeme-al/odeme-al.component';

@Component({
  selector: 'app-daire-borc-alacak-detail',
  templateUrl: './daire-borc-alacak-detail.component.html',
  styleUrls: ['./daire-borc-alacak-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DaireBorcAlacakDetailComponent implements OnInit {
  @Input() daireBorcAlacak: IDaireBorcAlacak;

  constructor(
    public app: AppService,
    private modalController: ModalController,
    private nav: IonNav,
    private platform: Platform
  ) { 
    this.platform.backButton.subscribeWithPriority(101, async () => {
      let canGoBack = await this.nav.canGoBack();
      if (canGoBack) {
        this.nav.pop();
      } else {
        await this.modalController.dismiss();
      }
      return;
    });
  }

  ngOnInit(): void {
  }
  
  borclandir(borclandir: IDaireBorcAlacak) {
    this.nav.push(BorclandirComponent, {
      borclandir
    })
  }

  odemeAl(odemeAl: IDaireBorcAlacak) {
    this.nav.push(OdemeAlComponent, {
      odemeAl
    })
  }
  
  cariHesapEkstresi() {
    this.nav.push(CariHesapEkstresiComponent, {
      rootModal: true
    })
  }

  async dismiss(dismissed: boolean) {
    await this.modalController.dismiss(dismissed);
  }
}
